<template>
  <div id="page-user-view">
    <vs-alert
      color="danger"
      title="User Not Found"
      :active.sync="user_not_found"
    >
      <span
        >User record with id: {{ $route.params.tenantsId }} not found.
      </span>
    </vs-alert>

    <div id="user-data" v-if="CompanyInformation">
      <vx-card class="mb-base">
        <div class="vx-col w-full">
          <div class="flex items-end px-3 text-primary">
            <feather-icon svgClasses="w-6 h-6" icon="UserIcon" class="mr-2" />
            <span class="font-medium text-xl leading-none text-primary"
              >Company Information</span
            >
          </div>
          <vs-divider />
        </div>
        <!-- Avatar -->
        <div class="vx-row">
          <!-- Avatar Col -->
          <div class="vx-col" id="avatar-col">
            <div class="img-container mb-4">
              <!-- photoUrl has an entry, so decided to comment it -->
              <!-- <div v-if="CompanyInformation.photoUrl !== ''">
                <p>
                  {{ CompanyInformation.photoUrl }}
                </p>

                <img
                  :src="CompanyInformation.photoUrl"
                  class="rounded w-full"
                />
              </div>
              <div v-else> -->
              <div>
                <vs-avatar
                  class="rounded-full shadow-md cursor-pointer block"
                  size="120px"
                  style="font-size: 50px"
                  :text="CompanyInformation.name"
                  :color="
                    color1 < 12
                      ? 'success'
                      : color1 <= 15
                      ? 'primary'
                      : color1 <= 20
                      ? 'warning'
                      : 'danger'
                  "
                />
              </div>
            </div>
          </div>

          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">Username:</td>
                <td>{{ CompanyInformation.name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Emp No.:</td>
                <td>{{ CompanyInformation.code }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Address:</td>
                <td>{{ CompanyInformation.address }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Telephone Number:</td>
                <td>{{ CompanyInformation.telNo }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Annual Working Days:</td>
                <td>{{ CompanyInformation.companyAnnualWorkingDays }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Working Hours per Day:</td>
                <td>{{ CompanyInformation.workingHoursInADay }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Active:</td>
                <vs-td CompanyInformation.isActive>
                  <vs-checkbox
                    v-model="CompanyInformation.isActive"
                    class="pointer-events-none"
                  />
                </vs-td>
              </tr>
            </table>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user_not_found: false,
      CompanyInformation: null,
      isActive: true,
    };
  },
  created() {
    this.$vs.loading();
    this.tenantsId = this.$route.params.tenantsId;
    console.log("Tenants ID:", this.tenantsId);
    const payload = {
      pageNumber: 1,
      pageSize: -1,
      sortBy: "CreatedOn",
      sortOrder: "Desc",
    };
    this.$store
      .dispatch("tenants/getTenantbyID", { tenantsId: this.tenantsId })
      .then((res) => {
        this.$vs.loading.close();
        if (res.data && res.data.data) {
          this.CompanyInformation = JSON.parse(JSON.stringify(res.data.data));
          console.log("tenantsId:", this.CompanyInformation);
        } else {
          console.error("Error: No data received from the API");
        }
      })
      .catch((err) => {
        this.$vs.loading.close();
        this.user_not_found = true;
        console.log("Error fetching tenant by ID. tenantsId:", this.tenantsId);
        console.error(err);
      });
  },
  computed: {
    color1() {
      return this.CompanyInformation.name.length;
    },
  },
};
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 10px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}

@media screen and (min-width: 1201px) and (max-width: 1211px),
  only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }
}
</style>
